import ky from 'ky';

import {UserData} from '~redux/types/user';

import {getOptions} from './api';

const AUTH_API = import.meta.env.VITE_AUTH_API ?? '';

export function getUser(): Promise<UserData> {
  return ky.get(`${AUTH_API}/users/me`, getOptions({signalId: 'getUser'})).json();
}

export function setDefaultProject(projectId: string): Promise<UserData> {
  const options = getOptions({signalId: 'setDefaultProject', data: {project: projectId}});
  return ky.put(`${AUTH_API}/users/default-project`, options).json();
}

export function setUserPreferences(landingPage: string): Promise<UserData> {
  const options = getOptions({signalId: 'setUserPreferences', data: {landingPage}});
  return ky.put(`${AUTH_API}/users/preference`, options).json();
}

export function syncCustomers(): Promise<UserData> {
  return ky.post(`${AUTH_API}/users/sync-customers`, getOptions({signalId: 'syncCustomers'})).json();
}
